import AmericanArchitectureFrame from "./components/AmericanArchitectureAwardFrame";
import AmericanArchitectureForm from "./components/AmericanArchitectureAwardForm";
import UserAccountRoutes from "../front_user_account/routes";

export default [
    {
        path: "/american-architecture-award",
        name: "american-architecture-award",
        redirect: "/american-architecture-award/account",
        meta: {
            auth: true,
            basePath: true,
            award: "americanarchitecture",
            awardName: "American Architecture Award",
        },
        component: AmericanArchitectureFrame,
        children: [
            {
                path: "",
                component: AmericanArchitectureForm,
                name: "american-architecture-award-form",
            },
            ...UserAccountRoutes,
        ],
    },

    /*/future-house-awards*/
];
